// extracted by css-extract-rspack-plugin
export default {"mask":"mask-K07oRY","inline":"inline-uinEhj","normal":"normal-TZCvNk","inverse":"inverse-OtAOZo"};